<template>
  <ModalComponent id="approaches_modal" title="Especialidades">
    <template v-slot:body>
      <div
        v-for="(approache, index) in approaches"
        :key="index"
        class="py-4"
        :class="{
          'border-bottom': index < approaches.length - 1,
          'border-0': index === approaches.length - 1,
          'pt-0': index === 0,
        }"
      >
        <p class="text-paragraph mb-0">{{ approache.info.title }}</p>
      </div>
    </template>
  </ModalComponent>
</template>

<script lang="ts">
import ApproachesController from "./ApproachesController";
export default ApproachesController;
</script>
